<script setup>
/**
 * PrintReport.vue
 * * Structural report print template layout. Formats incoming parameterized data sets
 * into isolated print matrices, handles locale-compliant moment date mutations,
 * and handles layout headers safely against delayed upstream hydration lifecycles.
 */
import { computed } from 'vue'
import moment from 'moment'

// 1. Definition of Component Properties
const props = defineProps({
    heading: {
        type: String,
        default: ''
    },
    date: {
        type: String,
        default: ''
    },
    startDate: {
        type: String,
        default: ''
    },
    endDate: {
        type: String,
        default: ''
    },
    rows: {
        type: Array,
        default: () => []
    }
})

// 2. Computed Reactive Mappings
const reportDate = computed(() => {
    return formatDate(new Date())
})

// 3. Specialized Helper Utilities
const formatDate = (timestamp) => {
    return moment(timestamp).format('Do MMMM YYYY')
}
</script>

<template>
    <div>
        <h1 style="font-size: 16px">
            {{ props.heading }}
        </h1>

        <div style="font-size: 11px">
            <p>
                {{ reportDate }}
            </p>

            <p v-if="props.startDate && props.endDate">
                Period - {{ formatDate(props.startDate) }} to {{ formatDate(props.endDate) }}
            </p>

            <table v-if="props.rows && props.rows.length" class="table table-condensed">
                <thead>
                <tr>
                    <td v-for="(value, key) in props.rows[0]" :key="'head-' + key">
                        {{ key }}
                    </td>
                </tr>
                </thead>

                <tbody>
                <tr v-for="(row, rowIndex) in props.rows" :key="'row-' + rowIndex">
                    <td v-for="(value, cellKey, cellIndex) in row" :key="'cell-' + rowIndex + '-' + cellIndex">
                        {{ value }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>